<template>
          

              
			<div class="wtips_uom_table_search col-wrapper col-lg-12 col-md-12 col-sm-12 col-xs-12">
			   
				<div class="module-wrapper">
				   
					<section class="module module-has-footer module-projects-overview">
					
						<div class="module-inner">
							<div class="module-heading">
								<h3 class="module-title">Unit of measure search</h3>
								<ul class="actions list-inline">
									<li><a class="collapse-module" data-toggle="collapse" href="#content-overview" aria-expanded="false" aria-controls="content-overview"><span aria-hidden="true" class="icon arrow_carrot-up"></span></a></li>
								</ul>
								<br>
								<button class="btn btn-warning" @click="return_parent"><i class="fa fa-mail-reply"></i>Go Back</button>
							</div>
							
							<div class="module-content collapse in" id="content-overview">
								<div class="module-content-inner">
                                    
                                     <label>Search UOM Code</label>
    				                 <div class="input-group col-md-3" style="z-index:0">
										  <input type="text" id="search_uom_text" class="form-control" placeholder="Search UOM code" v-model="search_uom">
										  <div class="input-group-addon" @click="search_uom_text"><i class="fa fa-search" ></i></div>
                                    </div>                            
                                
    							<div id="no-more-tables" class="table-responsive">
									<table class="table table-simple table-striped">
										<thead>
											<tr>
												<th>UOM Code</th>
												<th>UOB Desc</th>
												<th>Created User/Time</th>
												<th>Modified User/Time</th>
												<th>Actions</th>
											</tr>
										</thead>
										<tbody>
											<tr v-for="item in items" :key="item.id">
												<td data-title="UOM Code." ><a class="label label-number-alt" @click="select_uom(item.uom_code)">{{item.uom_code}}</a></td>
												<td data-title="UOB Desc." class="client truncate">{{item.uom_desc}}</td>
												<td data-title="Created User/Time" class="client truncate">{{item.cr_user_code}} / {{item.cr_datetime}}</td>
												<td data-title="Modified User/Time" class="client truncate">{{item.md_user_code}} / {{item.md_datetime}}</td>
												<td data-title="Actions">
                                                     <span>            
                                                      <button type="button" class="btn btn-default btn-sm" data-toggle="tooltip" data-placement="bottom" title="Select Record" @click="select_uom(item.uom_code)">
                                                        <span class="glyphicon glyphicon-open-file"></span> 
                                                      </button>                                                      
                                                    </span>
                                                </td>
											 </tr>											
										</tbody>
										
									</table>
    				            </div>                                
								                <nav class="text-center pagination-wrapper">
								                <br>
										            <p class="pagination-info">Displaying items {{page_info.from_page}}-{{page_info.to_page}} of {{page_info.record_count}}</p>
                                                    <div id="page-selection"></div>
									            </nav>                                   
								</div>
								
							</div>
							
						</div>
						
						 <spinner :visible="ajax_loader"></spinner>
					</section>
					
				</div>		
            </div>	
            


	
</template>

<script>
    
import modalnotify from '@/components/supportcomp/modalnotify.vue' 
import spinner from '@/components/supportcomp/spinner.vue' 

export default {
  name: 'uom_master_search',
  props: {
      uom_search_view: {
            type:Boolean
              },
      picked_element : '',
      parent_window : '',
      search_uom : ""
  },    
  data () {
    return {
      single_view : false,    
      msg: '',
      sideBarVisible : false,
      security_obj : { "access" : {"view" : true ,"edit" : false,"delete" : false}},
      modalnotify_view : false,
      modal_msg : '',   
      modal_title : '',
      ajax_loader : false,
      items : "",
      page_info : "",    
      page : ""
    }
  },
  components: {
      modalnotify,
      spinner
   },
methods: {
    
      refreshTabledetails : function (page){
                       
                            var x = this;
          
                             var object_data = {"data_api_key":'uom_master_search_data', "page" : page , "base_module":"uom_master", uom_search_text : x.search_uom };
                            
                             x.ajax_loader=true;
                             call_Ajax("get_data_api",object_data).then(function (data){
                                     
                                      x.ajax_loader=false;                                 
                                if (data=="No_records"){
                                      notify('No Records', 'warn',true,false,'topLeft');   
                                    
                                      x.items = [];
                                      x.page_info.to_page = "";
                                      x.page_info.from_page = "";
                                      x.page_info.Total_pages = 0;
                                    }
                                     else
                                         {                                 
                                 

                                      x.items = data.data;
                                             
                                      x.page_info.record_count=data.page_info.record_count;;         
                                 
                                      x.page_info.to_page = x.page_info.page_size*page;
                                      x.page_info.from_page = (x.page_info.to_page-(x.page_info.page_size-1));
                                    
                                      if (x.page_info.to_page > x.page_info.record_count)
                                          { x.page_info.to_page = x.page_info.record_count; }
                                      
                                      //x.page_info.Total_pages = data.page_info.Total_pages;
                                             
                                      $('#page-selection').bootpag({
                                             total: data.page_info.Total_pages
                                         });                                             
                                             
                                     window.scrollTo(0,0);
                                             
                                         }
                             })
                              .fail(function(){
                                 MstObj.ajax_loader=false; 
                             });               

      },
    
     setSecurity : function (){
              var x = this;

                            
                      var object_data = {"data_api_key":'uom_master_search_data', "page" : "1" , "base_module":"uom_master" , uom_search_text : x.search_uom};
                             x.ajax_loader=true;
                             call_Ajax("get_data_api",object_data).then(function (data){
                                 
                                      x.ajax_loader=false;                                 
                                 
                                if (data=="No_records"){
                                         notify('No Records', 'warn',true,false,'topLeft'); 
                                    }
                                     else
                                         {
                                      x.items = data.data;
                                      x.page_info = data.page_info;
                                      x.page_info.from_page = 1;
                                      x.page_info.to_page = data.page_info.page_size;

                                      $('#page-selection').bootpag({
                                             total: data.page_info.Total_pages
                                         }).on("page", function(event, num){
                                          
                                                //alert(num);         
                                                x.refreshTabledetails(num);
                                         });
                                             
                                 }
                             })
                              .fail(function(){
                                 x.ajax_loader=false; 
                             });                                 

         
         
         
      }, //

    uom_selected : function (uom_code) {
             var x = this;
             this.picked_uom_view = uom_code;
             $(".wtips_uom_table_view").hide(600);
             $(".wtips_uom_single_view").show(600);
             window.scrollTo(0,0)
    }, //
    
    return_parent : function () {
             var x = this;
        
             x.$emit("turn_off_view");
             $(".wtips_uom_table_search").hide(600);
             $(x.parent_window).show(600);
             

    }, //
    
    search_uom_text : function(event) {
        
           var x = this;
        
           x.refreshTabledetails(1);
        
    },
    
    select_uom : function (uom_code) {
        
        var x = this;

             x.$emit("turn_off_view");
             $(".wtips_uom_table_search").hide(600);
             $(x.parent_window).show(600);   
             
             x.$emit("select_uom_text",uom_code);
             
        
    }

}, //end of Methods //

    watch : {
    
    
    uom_search_view : function (value){
          
                             var x = this;
                         
                       if (value)
                           {
                             x.setSecurity();  
                           }

      }

},
    
mounted : function () {
       var x = this;


   } //end of mounted
}

</script>



// WEBPACK FOOTER //
// src/components/app-pages/uom-master/uom-master-search.vue